<vex-page-layout>
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <vex-page-layout-content *ngIf="!isLoading">
    <!-- <mat-progress-bar mode="indeterminate" *ngIf="isLoading$ | async"></mat-progress-bar>

    <div *ngIf="!(isLoading$  | async)"> -->
    <button
      class="ml-2"
      color="primary"
      mat-stroked-button
      type="button"
      (click)="onBack()">
      <mat-icon svgIcon="mat:arrow_back" *ngIf="!isRtl"></mat-icon>
      <mat-icon svgIcon="mat:arrow_forward" *ngIf="isRtl"></mat-icon>
      {{ "BACK.TEXT" | translate }}
    </button>

    <vex-secondary-toolbar
      current="{{
        salesQuotationForm.get('transactionNumber').value && mode != 'copy'
          ? salesQuotationForm.get('transactionNumber').value
          : ['NEW_SALES_QUOTATION.TEXT' | translate]
      }}">
      <div class="flex flex-row justify-between">
        <button
        *ngIf="mode =='view'"
        class="ml-2"
        color="primary"
        mat-flat-button
        type="button"
        (click)="getQuotationPDF(salesQuotationForm.get('id').value)">
        <mat-icon svgIcon="mat:print"></mat-icon> {{"PRINT.TEXT"|translate}}
      </button>
        <button
          *ngIf="mode != 'view'"
          class="ml-2"
          color="primary"
          mat-flat-button
          type="button"
          (click)="onBack()">
          <mat-icon svgIcon="mat:cancel"></mat-icon>
          {{ "CANCEL.TEXT" | translate }}
        </button>

        <div *ngIf="mode !== 'view'">
          <button
            *ngIf="
              SalesQuotationStatus[salesQuotationForm.get('status').value] ==
                SalesQuotationStatus.Draft.toString() ||
              SalesQuotationStatus[salesQuotationForm.get('status').value] ==
                SalesQuotationStatus.WaitingCustomerAcceptance.toString() ||
              mode == 'create' ||
              mode == 'copy'
            "
            class="ml-2"
            color="primary"
            mat-stroked-button
            type="button"
            (click)="onSave(mode == 'create' || mode == 'copy' ? 0 : null)">
            <mat-icon svgIcon="mat:save"></mat-icon>
            <span
              *ngIf="mode == 'create' || mode == 'copy'; else elseTemplate"
              >{{ "SAVE_DRAFT.TEXT" | translate }}</span
            >
            <ng-template #elseTemplate>
              <span>{{ "SAVE.TEXT" | translate }}</span>
            </ng-template>
          </button>

          <button
            *ngIf="
              mode == 'create' ||
              mode == 'copy' ||
              SalesQuotationStatus[salesQuotationForm.get('status').value] ==
                SalesQuotationStatus.Draft.toString() ||
              SalesQuotationStatus[salesQuotationForm.get('status').value] ==
                SalesQuotationStatus.RejectedByCustomer.toString()
            "
            class="ml-2"
            color="primary"
            mat-flat-button
            type="button"
            (click)="onSave(1)">
            <mat-icon svgIcon="mat:save"></mat-icon>
            {{ "SAVE_AND_SEND.TEXT" | translate }}
          </button>
        </div>
      </div>
    </vex-secondary-toolbar>

    <div
      class="pt-6 px-6 container"
      *ngIf="
        SalesQuotationStatus[salesQuotationForm.get('status').value] ==
        SalesQuotationStatus.RejectedByCustomer.toString()
      ">
      <div class="flex flex-col sm:flex-row gap-4">
        <div class="card flex-auto">
          <div class="px-6 py-2 border-b flex items-center">
            <h2 class="title m-0 text-red-600">
              {{ "CUSTOMER_NOTE.TEXT" | translate }} : "{{
                salesQuotationForm.get("customerNote").value
              }}"
            </h2>
          </div>
        </div>
      </div>
    </div>
    
<app-sales-quotation-pdf #hiddenReport [orderData]="this.salesQuotationForm.value" [factories]="factoriesList" [salesMen]="salesMenList" [addressList]="addressList"></app-sales-quotation-pdf>
    <Form [formGroup]="salesQuotationForm">
      <div class="p-6 container">
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="card flex-auto">
            <div class="px-6 py-4 border-b flex items-center">
              <h2 class="title m-0">
                {{ "SALES_QUOTATION_INFORMATION.TEXT" | translate }}
              </h2>
            </div>
            <div class="px-6 py-4 flex flex-col">
              <!-- <mat-form-field>
            <mat-label>Company</mat-label>
            <input
              matInput
              placeholder="Enter your company name&hellip;"
              required />
          </mat-form-field> -->

              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{
                    "TRANSACTIONUMBER.TEXT" | translate
                  }}</mat-label>
                  <input
                    formControlName="transactionNumber"
                    type="text"
                    matInput
                    placeholder="Enter your transaction Number&hellip;"
                    readonly="true" />
                </mat-form-field>

                <mat-form-field class="flex-1">
                  <mat-label>{{ "CUSTOMERCODE.TEXT" | translate }}</mat-label>
                  <input
                    id="customerCode"
                    formControlName="customerCode"
                    matInput
                    placeholder="Enter customer Code&hellip;"
                    required
                    readonly="true"
                    (click)="openSearchCustomer()" />
                  <mat-icon matIconSuffix svgIcon="mat:search"></mat-icon>

                  <mat-error
                    *ngIf="
                      (submitted ||
                        salesQuotationForm.get('customerCode').touched) &&
                      salesQuotationForm.get('customerCode').invalid
                    ">
                    {{ "REQUIRED_FIELD.TEXT" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{ "CUSTOMERNAME.TEXT" | translate }}</mat-label>
                  <input
                    formControlName="customerName"
                    matInput
                    placeholder="Enter your customer Name&hellip;"
                    readonly="true" />
                </mat-form-field>

                <mat-form-field class="flex-1">
                  <mat-label>{{ "SELECT_FACTORY.TEXT" | translate }}</mat-label>
                  <input
                    required="true"
                    type="text"
                    matInput
                    [formControl]="stateCtrl"
                    [matAutocomplete]="auto" />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    class="flex-1"
                    [displayWith]="displayFactory"
                    (optionSelected)="ondropDownSelected($event, 0)">
                    <mat-option
                      *ngFor="let factory of filteredFactories$ | async"
                      [value]="factory">
                      <span class="flex items-center">
                        <span class="flex flex-col">
                          <span class="body-1 leading-snug"
                            >{{ factory.code }} - {{ factory.name }}</span
                          >
                        </span>
                      </span>
                    </mat-option>
                    <!-- <mat-option *ngFor="let factory of factoriesList" [value]="factory.id"> 
                    {{ factory.name }}
                  </mat-option> -->
                  </mat-autocomplete>
                  <button
                    class="text-secondary"
                    mat-icon-button
                    matIconSuffix
                    type="button">
                    <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
                  </button>

                  <mat-error
                    *ngIf="
                      (submitted ||
                        salesQuotationForm.get('factoryId').touched) &&
                      salesQuotationForm.get('factoryId').invalid
                    ">
                    {{ "REQUIRED_FIELD.TEXT" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{
                    "TRANSACTIONDATE.TEXT" | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="transactionDate"
                    [matDatepicker]="datepickerRef" />
                  <!-- <mat-icon
                    matIconSuffix
                    id="grayIcon"
                    svgIcon="mat:date_range"></mat-icon> -->
                  <mat-datepicker-toggle
                    [for]="datepickerRef"
                    matIconSuffix></mat-datepicker-toggle>
                  <mat-datepicker #datepickerRef></mat-datepicker>
                  <!-- <mat-hint>Click on the icon to the right for a Datepicker</mat-hint> -->
                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{
                    "CUSTOMER_CURRENT_BALANCE.TEXT" | translate
                  }}</mat-label>
                  <input
                    [value]="
                      salesQuotationForm.get('custCurrentBalance')?.value
                        ? (
                            salesQuotationForm.get('custCurrentBalance')?.value | number: '1.0-4'
                          ): '0'
                    "
                    formControlName="custCurrentBalance"
                    matInput
                    placeholder="Enter your cust Current Balance&hellip;"
                    required
                    readonly="true" />
                    <span matSuffix  class="riyalsymbol text-gray-400">$</span>

                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{
                    "CUSTOMER_CREDIT_LIMIT.TEXT" | translate
                  }}</mat-label>
                  <input
                    [value]="
                      salesQuotationForm.get('custCreditLimit')?.value
                        ? (
                            salesQuotationForm.get('custCreditLimit')?.value
                            | number : '1.0-4'
                          )
                        : '0'
                    "
                    formControlName="custCreditLimit"
                    matInput
                    placeholder="Enter your cust Credit Limit&hellip;"
                    required
                    readonly="true" />
                    <span matSuffix  class="riyalsymbol text-gray-400">$</span>

                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{ "STATUS.TEXT" | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="status"
                    placeholder="Enter your status"
                    required
                    readonly="true" />
                </mat-form-field>
              </div>

              <div class="grid grid-cols-4 gap-3">
                <mat-checkbox class="col-span-1" formControlName="fromFactory"
                  >{{"ISFACTORYDELIVERY.TEXT"|translate}}</mat-checkbox
                >

                <mat-form-field
                  class="col-span-2"
                  *ngIf="
                    !this.salesQuotationForm.get('fromFactory')?.value &&
                    this.salesQuotationForm.get('customerCode')?.value 
                  ">
                  <mat-label>{{
                    "SELECT_ADDRESSES.TEXT" | translate
                  }}*</mat-label>

                  <!-- Chips for selected options -->
                  <mat-chip-grid #chipList aria-label="Fruit selection" [disabled]="mode=='view'">
                    <mat-chip-row
                    [disabled]="mode=='view'"
                      *ngFor="
                        let address of this.salesQuotationForm.get(
                          'customerAddressList'
                        ).value;
                        let i = index
                      "
                      (removed)="removeAddress(i)">
                      {{ getAddressName(address.id) }}
                      <button
                      [disabled]="mode=='view'"
                        matChipRemove
                        [attr.aria-label]="'remove ' + address.id">
                        x
                      </button>
                    </mat-chip-row>
                  </mat-chip-grid>
                  <input
                    required="true"
                    type="text"
                    matInput
                    [formControl]="stateCtrl3"
                    [matAutocomplete]="auto3"
                    [matChipInputFor]="chipList" />
                  <mat-autocomplete #auto3="matAutocomplete" class="flex-1">
                    <mat-option
                      *ngFor="let address of addressList"
                      [value]="address">
                      <span class="flex items-center">
                        <span class="flex flex-col">
                          <span class="body-1 leading-snug">
                            <mat-checkbox
                              [checked]="isAddressSelected(address)"
                              (change)="
                                toggleAddressSelection(address, $event.checked)
                              "
                              >{{ address.name }}
                            </mat-checkbox>
                          </span>
                        </span>
                      </span>
                    </mat-option>
                    <!-- <mat-option *ngFor="let factory of factoriesList" [value]="factory.id"> 
                    {{ factory.name }}
                  </mat-option> -->
                  </mat-autocomplete>
                  <button
                    class="text-secondary"
                    mat-icon-button
                    matIconSuffix
                    type="button">
                    <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
                  </button>

 
                </mat-form-field>
                <mat-error
                *ngIf="
                  (submitted ||
                  selectedAddresses.touched) &&
                  selectedAddresses.invalid
                ">
                {{ "REQUIRED_FIELD.TEXT" | translate }}
              </mat-error>
              </div>
              <!-- <div class="flex items-center justify-end gap-2">
            <button mat-button type="button">Cancel</button>
            <button color="primary" mat-flat-button type="button">Submit</button>
          </div> -->
            </div>
          </div>
        </div>
      </div>

      <vex-page-layout mode="card">
        <vex-page-layout-header class="h-6"></vex-page-layout-header>

        <vex-page-layout-content class="container">
          <div class="hidden sm:block mb-2 filter-div">
            <div class="flex flex-row items-center justify-between">
              <mat-button-toggle-group class="mt-4 sm:mt-0 rounded-8">
                <mat-button-toggle (click)="toggleAction(true)">{{
                  "QUOTATION_DETAILS.TEXT" | translate
                }}</mat-button-toggle>
                <mat-button-toggle (click)="toggleAction(false)">{{
                  "ATTACHMENTS.TEXT" | translate
                }}</mat-button-toggle>
              </mat-button-toggle-group>

              <button
                *ngIf="mode !== 'view'"
                color="primary"
                mat-flat-button
                type="button"
                (click)="addItem()">
                <mat-icon svgIcon="mat:add"></mat-icon>
                {{ "ADD.TEXT" | translate }}
              </button>
            </div>
          </div>
          <div
            class="card"
            id="quotation-details"
            *ngIf="isQuotationDetails && !isAttachments">
            <div class="table-container" formArrayName="salesQuotationLines">
              <table
                [dataSource]="salesQuotationLines.controls"
                class="mat-elevation-z8 mat-table-fixed"
                mat-table
                matSort>
                <!-- Index Column -->
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    <b> # </b>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    class="text-center">
                    {{ i + 1 }}
                  </td>
                </ng-container>
                <!-- Item Code Column -->
                <ng-container matColumnDef="itemCode">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "PRODUCT_CODE.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'itemCode') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'itemCode') }"
                        class="custom-height">
                        <input
                          matInput
                          (click)="openSearchProducts(i)"
                          formControlName="itemCode"
                          (input)="lineInputChanges(i)"
                          [placeholder]="'PRODUCT_CODE.TEXT' | translate"
                          required
                          readonly
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'itemCode')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- Item Name Column -->
                <ng-container matColumnDef="itemName">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "PRODUCT_NAME.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'itemName') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'itemName') }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="itemName"
                          (input)="lineInputChanges(i)"
                          required
                          readonly
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'itemName')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- Quantity Column -->
                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "QUANTITY.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'quantity') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'quantity') }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="quantity"
                          (input)="lineInputChanges(i, 'quantity')"
                          [value]="
                            getFormattedNumber(i, 'quantity') | number: '1.0-4'
                          "
                          required
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'quantity')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- Unit Column -->
                <ng-container matColumnDef="uom">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "UNIT.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'uom') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'uom') }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="uom"
                          (input)="lineInputChanges(i)"
                          required
                          readonly
                          [ngStyle]="{ 'width': getDynamicWidth(i, 'uom') }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- Unit Price Column -->
                <ng-container matColumnDef="unitPrice">
                  <th mat-header-cell *matHeaderCellDef><b>{{"UNIT_PRICE.TEXT"|translate}}</b></th>

                  <td mat-cell *matCellDef="let element; let i = index">
                    <div [formGroupName]="i" [ngStyle]="{ 'width': getDynamicWidth(i,'unitPrice') }">
                      <mat-form-field [ngStyle]="{ 'width': getDynamicWidth(i,'unitPrice') }" class="custom-height">
                        <input
                        formControlName="unitPrice"
                        (input)="lineInputChanges(i,'unitPrice')"
                        [value]="getFormattedNumber(i, 'unitPrice') | number:'1.0-4'" 
                        required matInput 
                        [ngStyle]="{ 'width': getDynamicWidth(i,'unitPrice') }"/>

                        <span matSuffix class="riyalsymbol" [ngClass]="{'text-gray-400':this.salesQuotationLines.at(i).get('unitPrice').disabled}">$</span>
                        </mat-form-field>

    
                    </div>
                  </td>
                </ng-container>

                <!-- VAT Column -->
                <ng-container matColumnDef="vatPercentage">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "VAT.TEXT" | translate }} %</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{
                        'width': getDynamicWidth(i, 'vatPercentage')
                      }">
                      <mat-form-field
                        [ngStyle]="{
                          'width': getDynamicWidth(i, 'vatPercentage')
                        }"
                        class="custom-height">
                        <input
                          formControlName="vatPercentage"
                          (input)="lineInputChanges(i, 'vatPercentage')"
                          type="number"
                          required
                          readonly
                          matInput
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'vatPercentage')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="totalBeforeVAT">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "TOTAL_BEFORE_VAT.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{
                        'width': getDynamicWidth(i, 'totalBeforeVAT')
                      }">
                      <mat-form-field
                        [ngStyle]="{
                          'width': getDynamicWidth(i, 'totalBeforeVAT')
                        }"
                        class="custom-height">
                        <input
                          formControlName="totalBeforeVAT"
                          (input)="lineInputChanges(i)"
                          [value]="
                            (
                              getFormattedNumber(i, 'totalBeforeVAT')
                              | number:'1.0-4'
                            )
                          "
                          required
                          readonly
                          matInput
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'totalBeforeVAT')
                          }" />
                          <span matSuffix  class="riyalsymbol text-gray-400">$</span>
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <!-- VAT Amount Column -->
                <ng-container matColumnDef="vatAmount">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "VAT_AMOUNT.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'vatAmount') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'vatAmount') }"
                        class="custom-height">
                        <input
                          formControlName="vatAmount"
                          (input)="lineInputChanges(i)"
                          [value]="
                            (
                              getFormattedNumber(i, 'vatAmount')
                              | number: '1.0-4'
                            )
                          "
                          required
                          readonly
                          matInput
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'vatAmount')
                          }" />
                            <span matSuffix  class="riyalsymbol text-gray-400">$</span>
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>
                <!-- Total Column -->
                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "TOTALS.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'total') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'total') }"
                        class="custom-height">
                        <input
                          formControlName="total"
                          (input)="lineInputChanges(i)"
                          [value]="
                            (
                              getFormattedNumber(i, 'total')
                              | number:'1.0-4'
                            )
                          "
                          required
                          readonly
                          matInput
                          [ngStyle]="{ 'width': getDynamicWidth(i, 'total') }" />
                          <span matSuffix  class="riyalsymbol text-gray-400">$</span>

                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button
                      color="warn"
                      mat-icon-button
                      type="button"
                      *ngIf="salesQuotationLines.at(i).valid && mode !== 'view'"
                      (click)="removeLine(i)">
                      <mat-icon svgIcon="mat:cancel"></mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr
                  *matRowDef="let row; columns: visibleColumns"
                  class="hover:bg-hover trans-ease-out cursor-pointer"
                  mat-row></tr>
              </table>
            </div>
          </div>

          <div
            class="card"
            id="attachments"
            *ngIf="isAttachments && !isQuotationDetails">
            <div class="table-container" formArrayName="documentAttachments">
              <table
                [dataSource]="documentAttachments.controls"
                class="mat-elevation-z8 mat-table-fixed"
                mat-table
                matSort>
                <!-- Index Column -->
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    <b> # </b>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    class="text-center">
                    {{ i + 1 }}
                  </td>
                </ng-container>
                <!-- Total Column -->
                <ng-container matColumnDef="filename">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "ATTACHMENT.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let row; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{
                        'width': getDynamicWidth(
                          i,
                          'filename',
                          'SELECT_FILE.TEXT' | translate
                        )
                      }">
                      <mat-form-field
                        [ngStyle]="{
                          'width': getDynamicWidth(
                            i,
                            'filename',
                            'SELECT_FILE.TEXT' | translate
                          )
                        }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="filename"
                          (input)="lineInputChanges(i, 'filename')"
                          type="text"
                          required
                          readonly
                          placeholder="{{ 'SELECT_FILE.TEXT' | translate }}"
                          (click)="fileInput.click()"
                          [ngStyle]="{
                            'width': getDynamicWidth(
                              i,
                              'filename',
                              'SELECT_FILE.TEXT' | translate
                            )
                          }" />
                        <mat-icon
                          matIconPrefix
                          svgIcon="mat:attach_file"></mat-icon>
                      </mat-form-field>
                      <input
                        #fileInput
                        type="file"
                        class="hidden"
                        (change)="onFileChange($event, i)"
                        accept=".jpg,.jpeg,.png,.gif,.pdf,.txt" />

                      <!-- <button class="hover:bg-hover cursor-pointer"
                        *ngIf="documentAttachments.controls[i]?.get('filename')?.valid"
                        matTooltip="{{ 'DOWNLOAD.TEXT' | translate }}">
                          <mat-icon svgIcon="mat:arrow_downward"></mat-icon>
                        </button> -->
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="download">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div [formGroupName]="i">
                      <a
                        *ngIf="
                          documentAttachments.controls[i]?.get('filename')
                            ?.value
                        "
                        (click)="onDownloadClick(i)"
                        href="{{ downloadLink }}"
                        download="{{
                          documentAttachments.controls[i]?.get('filename').value
                        }}"
                        >{{ "DOWNLOAD.TEXT" | translate }}</a
                      >
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="attachedBy">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "ATTACHED_BY.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'attachedBy') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'attachedBy') }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="attachedBy"
                          (input)="lineInputChanges(i)"
                          type="text"
                          required
                          readonly
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'attachedBy')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="dateAndTime">
                  <th mat-header-cell *matHeaderCellDef>
                    <b>{{ "DATE_AND_TIME.TEXT" | translate }}</b>
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <div
                      [formGroupName]="i"
                      [ngStyle]="{ 'width': getDynamicWidth(i, 'dateAndTime') }">
                      <mat-form-field
                        [ngStyle]="{ 'width': getDynamicWidth(i, 'dateAndTime') }"
                        class="custom-height">
                        <input
                          matInput
                          formControlName="dateAndTime"
                          (input)="lineInputChanges(i)"
                          type="text"
                          required
                          readonly
                          [ngStyle]="{
                            'width': getDynamicWidth(i, 'dateAndTime')
                          }" />
                      </mat-form-field>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button
                      color="warn"
                      mat-icon-button
                      type="button"
                      *ngIf="documentAttachments.at(i).valid && mode !== 'view'"
                      (click)="removeLine(i)">
                      <mat-icon svgIcon="mat:cancel"></mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr
                  *matHeaderRowDef="visibleColumnsAttachments"
                  mat-header-row></tr>
                <tr
                  *matRowDef="let row; columns: visibleColumnsAttachments"
                  class="hover:bg-hover trans-ease-out cursor-pointer"
                  mat-row></tr>
              </table>
            </div>
          </div>
        </vex-page-layout-content>
      </vex-page-layout>

      <div class="p-6 container">
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="card flex-auto">
            <div class="px-6 py-4 border-b flex items-center">
              <h2 class="title m-0">
                {{ "SALES_QUOTATION_INFORMATION.TEXT" | translate }}
              </h2>
            </div>

            <div class="px-6 py-4 flex flex-col">
              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field class="flex-1">
                  <mat-label>{{ "SALESMAN.TEXT" | translate }}</mat-label>
                  <input
                    type="text"
                    matInput
                    [formControl]="stateCtrl2"
                    [matAutocomplete]="auto2"
                    required />

                  <mat-autocomplete
                    #auto2="matAutocomplete"
                    class="flex-1"
                    [displayWith]="displaySalesMan"
                    (optionSelected)="ondropDownSelected($event, 1)">
                    <mat-option
                      *ngFor="let salesMan of salesMenList$ | async"
                      [value]="salesMan">
                      <span class="flex items-center">
                        <span class="flex flex-col">
                          <span class="body-1 leading-snug"
                            >{{ salesMan.userCode }} -
                            {{ salesMan.userName }}</span
                          >
                        </span>
                      </span>
                    </mat-option>
                    <!-- <mat-option *ngFor="let factory of factoriesList" [value]="factory.id"> 
                    {{ factory.name }}
                  </mat-option> -->
                  </mat-autocomplete>
                  <button
                    class="text-secondary"
                    mat-icon-button
                    matIconSuffix
                    type="button">
                    <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
                  </button>

                  <mat-error>
                    {{ "REQUIRED_FIELD.TEXT" | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{ "VAT.TEXT" | translate }} %</mat-label>
                  <input
                    formControlName="vatPercentage"
                    matInput
                    placeholder="Enter your VAT Percentage&hellip;"
                    required
                    readonly="true" />
                </mat-form-field>
                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{
                    "TOTAL_BEFORE_VAT.TEXT" | translate
                  }}</mat-label>
                  <input
                    [value]="
                      (
                        salesQuotationForm.get('totalBeforeVAT').value
                        | number: '1.0-4'
                      )
                    "
                    formControlName="totalBeforeVAT"
                    matInput
                    placeholder="Enter your total Before VAT&hellip;"
                    required
                    readonly="true" />
                    <span matSuffix  class="riyalsymbol text-gray-400">$</span>

                </mat-form-field>

                <mat-form-field class="flex-1" hideRequiredMarker="true">
                  <mat-label>{{ "VAT_AMOUNT.TEXT" | translate }}</mat-label>
                  <input
                    [value]="
                      (
                        salesQuotationForm.get('vatAmount').value
                        | number:'1.0-4'
                      )
                    "
                    formControlName="vatAmount"
                    matInput
                    placeholder="Enter your VAT Amount&hellip;"
                    required
                    readonly="true" />
                    <span matSuffix  class="riyalsymbol text-gray-400">$</span>
                </mat-form-field>
              </div>

              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field
                  class="flex-none sm:w-1/4 sm:ltr:pr-3 sm:rtl:pl-3"
                  hideRequiredMarker="true">
                  <mat-label>{{ "TOTALS.TEXT" | translate }}</mat-label>
                  <input
                    [value]="
                      (
                        salesQuotationForm.get('total').value
                        | number: '1.0-4'
                      )
                    "
                    formControlName="total"
                    matInput
                    placeholder="Enter your total&hellip;"
                    required
                    readonly="true" />
                    <span matSuffix  class="riyalsymbol text-gray-400">$</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-6 container">
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="card flex-auto">
            <div class="px-6 py-4 border-b flex items-center">
              <h2 class="title m-0">{{ "NOTES.TEXT" | translate }}</h2>
            </div>

            <div class="px-6 py-4 flex flex-col">
              <div class="flex flex-col sm:flex-row sm:gap-4">
                <mat-form-field class="flex-1">
                  <mat-label>{{ "NOTES.TEXT" | translate }}</mat-label>
                  <input
                    formControlName="notes"
                    matInput
                    placeholder="Enter your note here&hellip;" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-6 container">
        <div class="flex flex-col sm:flex-row gap-4">
          <div class="card flex-auto">
            <div class="px-6 py-4 border-b flex items-center">
              <h2 class="title m-0">{{ "EXTRA_INFO.TEXT" | translate }}</h2>
            </div>
            <div class="px-6 py-4 flex flex-col">
              <div class="flex flex-col sm:gap-4">
                <div formArrayName="validationCheckBoxes" class="grid grid-cols-2 gap-4">
                  <div *ngFor="let checkbox of salesQuotationCheckBoxes; let i = index">
                    <mat-checkbox [formControlName]="i">
                      {{ isRtl?checkbox.nameAr:checkbox.nameEn}} <!-- Display the checkbox label -->
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <!-- </div> -->
  </vex-page-layout-content>
</vex-page-layout>
